import { triggerReconnection } from '@lib/subscriptions/webSocketReconnectedVar'
import {
  AuthConfig,
  initializeApollo,
} from '@mono/packages/graphql/apollo/apollo'
import { GraphqlApi } from '@mono/packages/graphql/apollo/constants'
import { useMemo } from 'react'
import { cache } from './cache'
import { ACCOUNT_FULL_FRAGMENT } from './fragments/Organization'
import { showFailureToast } from './variables/toastState'

const resolvers = {
  Notification: {
    actor: (notification, _, { cache }) => {
      return cache.readFragment({
        id: 'Account:' + notification?.actor?.id,
        fragment: ACCOUNT_FULL_FRAGMENT,
        fragmentName: 'AccountFullFragment',
      })
    },
  },
}

export function useApollo(
  defaultApiContext: GraphqlApi,
  authConfig: AuthConfig,
  initialState?: any,
) {
  const store = useMemo(
    () =>
      initializeApollo(initialState, {
        defaultApiContext,
        authConfig,
        resolvers,
        cache,
        triggerReconnection,
        showErrorToast: showFailureToast,
      }),
    [defaultApiContext, authConfig, initialState],
  )
  return store
}
